var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ remMargin:_vm.$store.state.isMobile },attrs:{"id":"notFound"}},[_c('h1',[_vm._v("Halaman tidak ada.")]),_c('router-link',{attrs:{"to":"/"}},[_c('button',[_vm._v("Home")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }